import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/21/principle/sti-0.svg`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
];

export default components;
